import { NavLink, Stack, Text } from '@mantine/core';
import {
  IconInbox,
  IconClipboardList,
  IconSettings,
  IconBuildingFactory2,
} from '@tabler/icons-react';
import { useLocation, useNavigate } from 'react-router-dom';

export function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string) => location.pathname === path;

  const navItems = [
    {
      icon: <IconInbox size={20} />,
      label: 'Orders',
      path: '/',
      description: 'Manage service delivery orders',
    },
    {
      icon: <IconClipboardList size={20} />,
      label: 'Tasks',
      path: '/tasks',
      description: 'View and manage tasks',
    },
    {
      icon: <IconBuildingFactory2 size={20} />,
      label: 'FNOs',
      path: '/fnos',
      description: 'Fiber Network Operators',
    },
    {
      icon: <IconSettings size={20} />,
      label: 'Settings',
      path: '/settings',
      description: 'System configuration',
    },
  ];

  return (
    <>
        <Stack gap="xs">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              leftSection={item.icon}
              label={item.label}
              description={item.description}
              active={isActive(item.path)}
              onClick={() => navigate(item.path)}
              style={(theme) => ({
                root: {
                  borderRadius: theme.radius.md,
                  '&[data-active]': {
                    backgroundColor: theme.colors.brand[0],
                  },
                },
              })}
            />
          ))}
        </Stack>
        <Text size="xs" c="dimmed" ta="center" py="md">
          Service Delivery Portal v1.0
        </Text>
    </>
  );
}
